<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title>{{ "Planning clients".toUpperCase() }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <mat-accordion>
      <mat-expansion-panel [expanded]="expanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'30px'"
          [expandedHeight]="'30px'"
        ></mat-expansion-panel-header>
        <div class="btn">
          <button (click)="afficherDate()" mat-raised-button color="primary">
            <mat-icon>search</mat-icon>Afficher
          </button>
        </div>
        <div class="marginRight10">
          <mat-form-field appearance="outline">
            <mat-label>Clients</mat-label>
            <mat-select
              [disabled]="disabled"
              (selectionChange)="afficherDate()"
              placeholder="Clients"
              name="Clients"
              [(ngModel)]="client"
            >
              <mat-option
                *ngFor="let Tiers of listeClients"
                [(ngModel)]="Tiers.Tiers_code"
              >
                {{ Tiers.Tiers_NomPublic }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Du</mat-label>
            <input
              matInput
              [matDatepicker]="dateDebut"
              placeholder="Du"
              [(ngModel)]="date_Debut"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dateDebut"
            ></mat-datepicker-toggle>
            <mat-datepicker #dateDebut></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Au</mat-label>
            <input
              matInput
              [matDatepicker]="dateFin"
              placeholder="Au"
              [(ngModel)]="date_Fin"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dateFin"
            ></mat-datepicker-toggle>
            <mat-datepicker #dateFin></mat-datepicker>
          </mat-form-field>
        </div>
        <mat-list fxLayout>
          <mat-list-item *ngFor="let week of listWeek" fxFlex>
            <div class="example-button-row width100">
              <button
                [disabled]="!week.enable"
                class="width100"
                mat-raised-button
                (click)="showDetaille(week.monthName, 7)"
                color="primary"
              >
                <span>{{ week.colSpan }}</span
                >&nbsp;&nbsp;<span style="font-size: 10px">{{
                  week.monthName
                }}</span>
              </button>
            </div>
          </mat-list-item>
        </mat-list>
        <mat-list fxLayout>
          <mat-list-item *ngFor="let month of listMonth" fxFlex>
            <div class="example-button-row width100">
              <button
                [disabled]="!month.enable"
                class="width100"
                (click)="
                  showDetaille(
                    '1/' + (month.monthId + 1) + '/' + month.year,
                    30
                  )
                "
                mat-raised-button
                color="primary"
              >
                {{ month.monthName }}
              </button>
            </div>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </mat-accordion>

    <div style="margin-top: 10px">
      <app-calendar
        *ngIf="showCalendar"
        [events]="events"
        [intervale]="intervale"
        [date_Fin]="date_Fin"
        [date_Debut]="date_Debut"
        [defaultDate]="defaultDate"
        (actionCalendar)="actionCalendar($event)"
      >
      </app-calendar>
    </div>
  </mat-card-content>
</mat-card>
